import { ModelBase, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class SourceFieldStaticOptionLookup extends ModelBase {
    public sourceFieldStaticOptionID: number = 0;

    public sourceFieldName: string = "";
}